export const tabela =[
    {
        sigla: 'Ref',
        nome:{
            pt: 'Referência', en: 'Referência', es: 'Referencia',fr: 'Référence', it:'Riferimento', zh: "代码"
        },
    },
    {
        sigla: 'W',
        nome: {
            pt: 'Potência', en: 'Power', es: 'Potencia',fr: 'Puissance', it:'Potenza', zh: "代码"
        },
    },
    {
        sigla: 'K',
        nome: {
            pt: 'Temperatura de cor de luz', en: 'Light colour temperature', 
            es: 'Temperatura de color de la luz',fr: 'Température de couleur de la lumière', it:'Temperatura di colore della luce', zh: "灯光色温"
        },
    },
    {
        sigla: 'V',
        nome: {
            pt: 'Voltagem', en: 'Voltage', 
            es: 'Tensión',fr: 'Tension', it:'Tensione', zh: "电压"
        },
    },
    {
        sigla: 'LM',
        nome: {
            pt: 'Fluxo Luminoso', en: 'Luminous flux', 
            es: 'Flujo luminoso',fr: 'Flux lumineux', it:'Flusso luminoso', zh: "光通量"
        },
    },
    {
        sigla: 'CRI',
        nome: {
            pt: 'Índice de reprodução cromática', en: 'Colour rendering index', 
            es: 'Índice de reproducción cromática',fr: 'Indice de rendu des couleurs', it:'Indice di resa cromatica', zh: "顯色指數"
        },
    },
    {
        sigla: 'AC',
        nome: {
            pt: 'Corrente alternada', en: 'Alternating current', 
            es: 'Corriente alterna',fr: 'Courant alternatif', it:'Corrente alternata', zh: "交流电"
        },
    },
    {
        sigla: 'DC',
        nome: {
            pt: 'Corrente contínua', en: 'Direct current', 
            es: 'Corriente continua',fr: 'Courant continu', it:'Corrente continua', zh: "直流电"
        },
    },
    {
        sigla: 'Furo',
        nome:  {
            pt: 'Furo', en: 'Hole', 
            es: 'Agujero',fr: 'Trou', it:'Foro', zh: "孔洞"
        },
    },
    {
        sigla: 'Â',
        nome:  {
            pt: 'Ângulo de feixe de de luz', en: 'Light beam angle', 
            es: 'Ángulo del haz luminoso',fr: 'Angle du faisceau lumineux', it:'Angolo del fascio di luce', zh: "光束角度"
        },
    },
    {
        sigla: 'H',
        nome: {
            pt: 'Autonomia', en: 'Autonomy', 
            es: 'Autonomía',fr: "L'autonomie", it:'Autonomia', zh: "自主性"
        },
    },
    {
        sigla: 'QT/CX',
        nome: {
            pt: 'Quantidade por caixa', en: 'Quantity per box', es: 'Cantidad por caja',
            fr: "Quantité par boîte", it:'Quantità per scatola', zh: "每盒数量"
        },
    },
    {
        sigla: 'UGR',
        nome: {
            pt: 'Índice de Brilho Unificado', en: 'Unified Brightness Index', es: 'Índice de luminosidad unificado',
            fr: "Indice de luminosité unifié", it:'Indice di luminosità unificato', zh: "统一亮度指数"
        },
    },
]

export const material =[
    {
        sigla: 'ALUM',
        nome: {
            pt: 'Alumínio', en: 'Aluminium', es: 'Aluminio',
            fr: "Aluminium", it:'Alluminio', zh: "铝"
        },
    },
    {
        sigla: 'INOX',
        nome: {
            pt: 'Inox', en: 'Stainless steel', es: 'Acero inoxidable'
            ,fr: "Acier inoxydable", it:'Acciaio inox', zh: "氧化物"
        },
    },
    {
        sigla: 'MT',
        nome: {
            pt: 'Metal', en: 'Metal', es: 'Metal',
            fr: "Métal", it:'Metallo' , zh: "金属"
        },
    },
    {
        sigla: 'SIL',
        nome: {
            pt: 'Silicone', en: 'Silicone', es: 'Silicona',
            fr: "Silicone", it:'Silicone', zh: "硅胶"
        },
    },
    {
        sigla: 'VD',
        nome: {
            pt: 'Vidro', en: 'Glass', es: 'Vidrio',
            fr: "Verre", it:'Vetro', zh: "玻璃"
        },
    },
    {
        sigla: 'ACR',
        nome: {
            pt: 'Acrílico', en: 'Acrylic', 
            es: 'Acrílico',fr: "Acrylique", it:'Acrilico' , zh: "玻璃"
        },
    },
    {
        sigla: 'PC',
        nome: {
            pt: 'Policarbonato', en: 'Polycarbonate', 
            es: 'Policarbonato',fr: "Polycarbonate", it:'Policarbonato', zh: "聚碳酸酯"
        },
    },
    {
        sigla: 'CRM',
        nome: {
            pt: 'Cerâmica', en: 'Ceramics', es: 'Cerámica',
            fr: "Céramique", it:'Ceramica', zh: "陶瓷"
        },
    },
]

export const ip =[
    {
        sigla: 'IP20',
        nome: {
            pt: 'Poeira', en: 'Dust', 
            es: 'Polvo',fr: "Poussière", it:'Polvere'
        },
    },
    {
        sigla: 'IP40',
        nome:{
            pt: 'Poeira', en: 'Dust', 
            es: 'Polvo',fr: "Poussière", it:'Polvere'
        },
    },
    {
        sigla: 'IP44',
        nome: {
            pt: 'Salpicos e Poeira', en: 'Splashes and dust', 
            es: 'Salpicaduras y polvo',fr: "Éclaboussures et poussière", it:'Schizzi e polvere'
        },
    },
    {
        sigla: 'IP54',
        nome: {
            pt: 'Salpicos e Poeira', en: 'Splashes and dust', 
            es: 'Salpicaduras y polvo',fr: "Éclaboussures et poussière", it:'Schizzi e polvere'
        },
    },
    {
        sigla: 'IP65',
        nome: {
            pt: 'Poeira e jatos de água de baixa pressão', en: 'Dust and low-pressure water jets', 
            es: 'Polvo y chorros de agua a baja presión',fr: "Poussière et jets d'eau à basse pression", it:"Polvere e getti d'acqua a bassa pressione"
        },
    },
    {
        sigla: 'IP67',
        nome:  {
            pt: 'Poeira e efeitos da imersão até 1m ou 30 mis', en: 'Dust and immersion effects up to 1m or 30 mis', 
            es: 'Efectos de polvo e inmersión hasta 1 m o 30 mis',fr: "Effets de la poussière et de l'immersion jusqu'à 1 m ou 30 m",
            it:"Effetti della polvere e dell'immersione fino a 1 m o 30 mis"
        },
    },
    {
        sigla: 'IP68',
        nome:  {
            pt: 'Totalmente á prova de poeira e água', en: 'Fully dust and waterproof', 
            es: 'Totalmente resistente al polvo y al agua',fr: "Entièrement étanche à la poussière et à l'eau",
            it:"Completamente impermeabile e antipolvere"
        },
    },
    {
        sigla: 'IP69K',
        nome:  {
            pt: 'Máxima proteção contra poeiras e infiltrações de água', en: 'Maximum protection against dust and water infiltration', 
            es: 'Máxima protección contra el polvo y las infiltraciones de agua',fr: "Protection maximale contre les infiltrations de poussière et d'eau",
            it:"Massima protezione contro le infiltrazioni di polvere e acqua"
        },
    },
]